import React from 'react';
import { Button, IconButton } from '@mui/material';
import ChevronLeft from '@mui/icons-material/ChevronLeft';
import ChevronRight from '@mui/icons-material/ChevronRight';
import VisibleTabs from './VisibleTabs';

const CourseNavigation = ({ sections, activeIndex, setActiveIndex, visitedPages }) => {
  const handleNavigation = (index) => {
    setActiveIndex(index);
  };

  const handlePrevious = () => {
    if (activeIndex > 0) setActiveIndex(activeIndex - 1);
  };

  const handleNext = () => {
    if (activeIndex < sections.length - 1) setActiveIndex(activeIndex + 1);
  };

  return (
    <div className="flex-container navbar">
      {window.innerWidth > 600 ? (
        <Button
          disabled={activeIndex === 0}
          onClick={handlePrevious}
          startIcon={<ChevronLeft />}
          sx={{ padding: `${window.innerWidth > 600 ? '0px 30px' : '0px'}` }}>
          {window.innerWidth > 600 ? 'Previous' : ''}
        </Button>
      ) : (
        <IconButton
          disabled={activeIndex === 0}
          onClick={handlePrevious}
          color="primary"
          style={{ padding: '0px' }}>
          <ChevronLeft />
        </IconButton>
      )}

      {activeIndex > 2 && (
        <div className="ellipsis-left flex-container justify-center align-center">
          <p>...</p>
        </div>
      )}

      <VisibleTabs
        sections={sections}
        activeIndex={activeIndex}
        handleNavigation={handleNavigation}
        visitedPages={visitedPages}
      />

      {activeIndex < sections.length - 3 && (
        <div className="ellipsis-right flex-container justify-center align-center">
          <p>...</p>
        </div>
      )}

      {window.innerWidth > 600 ? (
        <Button
          disabled={activeIndex === sections.length - 1}
          endIcon={<ChevronRight />}
          onClick={handleNext}
          sx={{ padding: `${window.innerWidth > 600 ? '0px 30px' : '0px'}` }}>
          {window.innerWidth > 600 ? 'Next' : ''}
        </Button>
      ) : (
        <IconButton
          disabled={activeIndex === sections.length - 1}
          onClick={handleNext}
          color="primary"
          style={{ padding: '0px' }}>
          <ChevronRight />
        </IconButton>
      )}

      <style jsx>
        {`
          .navbar {
            display: flex;
            justify-content: space-between;
            margin-bottom: 20px;
            border-bottom: 1px solid lightgrey;
          }
          .ellipsis-left {
            padding: 0px 10px;
            border-right: 1px solid lightgrey;
            border-left: 1px solid lightgrey;
          }
          .ellipsis-right {
            padding: 0px 10px;
            border-right: 1px solid lightgrey;
          }
          .ellipsis-left p,
          .ellipsis-right p {
            margin-top: -8px;
          }
          @media only screen and (max-width: 400px) {
            .ellipsis-left,
            .ellipsis-right {
              padding: 0px 5px;
            }
          }
        `}
      </style>
    </div>
  );
};

export default CourseNavigation;
